module.exports = __webpack_public_path__ + "static/media/mavic2.0c26849a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/mavic2.jpg
// module id = 316
// module chunks = 0